export enum AppName {
  InsightsAgent = "Insights Agent",
  ConceptLearningAgent = "Concept Learning Agent",
  ProductLearningAgent = "Product Learning Agent",
}

export function getAppName(
  isChatFirst: boolean,
  isProductTesting: boolean,
): string {
  return isChatFirst
    ? isProductTesting
      ? AppName.ProductLearningAgent
      : AppName.ConceptLearningAgent
    : AppName.InsightsAgent;
}
